var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketIconOutlineMono = function SvgTicketIconOutlineMono(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M21.17 4c1 0 1.83.85 1.83 1.9v3.81c-.58 0-1.14.25-1.56.67a2.33 2.33 0 0 0 0 3.24c.42.42.98.67 1.56.67v3.8c0 1.06-.82 1.91-1.83 1.91H2.83A1.87 1.87 0 0 1 1 18.1v-3.81c.58 0 1.14-.25 1.56-.67a2.33 2.33 0 0 0 0-3.24A2.2 2.2 0 0 0 1 9.71v-3.8C1 4.84 1.82 4 2.83 4zM2.83 8.27q.57.3 1.02.77l.14.15c.62.72 1 1.64 1.04 2.6V12c0 1.04-.37 2.04-1.04 2.81l-.14.15q-.45.48-1.02.77v2.37h18.34v-2.37q-.48-.25-.88-.62l-.14-.15a4.3 4.3 0 0 1-1.18-2.75V12c0-1.11.42-2.18 1.18-2.96l.14-.15q.4-.38.88-.62V5.9H2.83z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketIconOutlineMono);
export default ForwardRef;